import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter, useHistory, Redirect } from 'react-router-dom'
import { categoriesApi } from '../../../api/categoriesApi'
import { categoriesActions } from '../../../actions/categoriesActions'
import { routes } from '../../../constantes/routes'
import Search from '../../common/Search'
import PlusBtn from '../../buttons/PlusBtn'
import CategoriesList from './CategoriesList'
import NewCategoriesModal from './NewCategoriesModal'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { onSubmitText } from '../../../constantes/onSubmitText'
import EditCategoriesModal from './EditCategoriesModal'
import Header from '../../header/Header'
import validators from '../../../utils/validationsRegEx'
import { categoriesTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { downloadCSV } from '../../../utils/downloadCSV'
import { exportActions } from '../../../actions/exportActions'
import { entitiesExport } from '../../../constantes/exportEndpoints'

const CategoriesContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const allCategories = useSelector((state) => state.categories)
  const [items, setItems] = useState(allCategories)

  const [newCategories, setNewCategories] = useState({})
  const [editCategories, setEditCategories] = useState({})
  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  const dispatch = useDispatch()
  const getAllCategories = () => dispatch(categoriesActions.getAllCategories())
  const newCategory = (category) =>
    dispatch(categoriesActions.newCategory(category))
  const updateCategory = (category) =>
    dispatch(categoriesActions.updateCategory(category))
  const deleteCategory = (idCategory) =>
    dispatch(categoriesActions.deleteCategory(idCategory))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllCategories()
    }
  }, [])

  useEffect(() => {
    setItems(allCategories)
  }, [allCategories])

  const openNewModal = () => {
    setNewCategories({ businessUnits: [] })
    setIsOpen({
      createModal: true,
      editModal: false,
    })
  }

  const openEditModal = (category) => {
    setEditCategories({
      ...category,
      businessUnits:
        category.id_NegocioUnidades || category.businessUnits || [],
    })
    setIsOpen({
      createModal: false,
      editModal: true,
    })
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...categoryData } = newCategories
      const dataToSend = {
        ...categoryData,
        id_NegocioUnidades: businessUnits || [],
      }

      const response = await newCategory(dataToSend)
      if (categoriesTypes.NEW_CATEGORY_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
        // Refrescar la lista de categorías después de la creación
        getAllCategories()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleSubmitUpdate = async (event) => {
    event.preventDefault()
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...categoryData } = editCategories
      const dataToSend = {
        ...categoryData,
        id_NegocioUnidades: businessUnits || [],
      }

      const response = await updateCategory(dataToSend)

      if (categoriesTypes.UPDATE_CATEGORY_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
        // Refrescar la lista de categorías después de la actualización
        getAllCategories()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleRemove = async (idCategory) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar esta categoría? Se eliminaran todos los productos que contenga',
      )
      if (alert.isConfirmed) {
        const response = await deleteCategory(idCategory)

        if (categoriesTypes.DELETE_CATEGORY_SUCCESS === response.type) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
          // Refrescar la lista de categorías después de la eliminación
          getAllCategories()
        }
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNewCategory = (e) => {
    const value = e.target.value
    const name = e.target.name
    setNewCategories({ ...newCategories, [name]: value })
  }

  const handleChangeEditCategory = (event) => {
    const value = event.target.value
    const name = event.target.name
    setEditCategories((editCategories) => ({
      ...editCategories,
      [name]: value,
    }))
  }

  const validateFormNew = () => {
    return (
      validators.hasValue(newCategories.nombre) &&
      newCategories.businessUnits &&
      newCategories.businessUnits.length > 0
    )
  }

  const validateFormEdit = () => {
    return (
      validators.hasValue(editCategories.nombre) &&
      editCategories.businessUnits &&
      editCategories.businessUnits.length > 0
    )
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allCategories.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.CATEGORIES),
    )
    downloadCSV("Categorias", response)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Categorías de los productos'}
            route={toBackoffice}
            backBtn={true}
          />
          <div className='filter__wrap mb-80'>
            <Search
              onChangeSearch={onChangeSearch}
              placeholder='Buscar por nombre...'
            />
            <div className='add__action__rigth__side'>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginLeft: '20px' }}
              >
                <span>📊 Exportar CSV</span>
              </button>
              <button className="action-button" onClick={openNewModal}>
                <PlusBtn />
                <span>Nueva categoría</span>
              </button>
            </div>
          </div>
          <CategoriesList
            allCategories={items}
            handleRemove={handleRemove}
            userProfile={userProfile}
            openEditModal={openEditModal}
          />
          <NewCategoriesModal
            newCategories={newCategories}
            modalIsOpen={modalIsOpen.createModal}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            handleChange={handleChangeNewCategory}
            validateForm={validateFormNew}
            textBtn={onSubmitText.Crear}
          />
          <EditCategoriesModal
            editCategories={editCategories}
            modalIsOpen={modalIsOpen.editModal}
            closeModal={closeModal}
            handleSubmit={handleSubmitUpdate}
            handleChange={handleChangeEditCategory}
            validateForm={validateFormEdit}
            textBtn={onSubmitText.Guardar}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(CategoriesContainer)
